import styled from 'styled-components';

export const StyledRightComponent = styled.div`
  display: flex;
  justify-content: flex-end;
  width: -webkit-fill-available;
  margin-left: 5px;
`;
